// ============================================
// ハンバーガーメニュー
// ============================================

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');
  const hamburger = document.querySelector('.header__hamburger');
  const nav = document.querySelector('.header__nav');
  const body = document.body;

  if (header) {
    const updateHeaderOnScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };

    updateHeaderOnScroll();
    window.addEventListener('scroll', updateHeaderOnScroll, { passive: true });
  }

  if (!hamburger || !nav) return;

  const setMenuOpen = function (isOpen) {
    nav.classList.toggle('is-open', isOpen);
    hamburger.classList.toggle('is-active', isOpen);
    body.classList.toggle('menu-open', isOpen);
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    hamburger.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
  };

  hamburger.addEventListener('click', function () {
    setMenuOpen(!nav.classList.contains('is-open'));
  });

  nav.querySelectorAll('a').forEach(function (item) {
    item.addEventListener('click', function () {
      setMenuOpen(false);
    });
  });

  document.addEventListener('click', function (e) {
    if (!hamburger.contains(e.target) && !nav.contains(e.target)) {
      setMenuOpen(false);
    }
  });
});

// ============================================
// ページ上部へ戻る（フッター）
// ============================================

document.addEventListener('DOMContentLoaded', function () {
  const toTop = document.getElementById('footer-to-top');
  if (!toTop) return;

  const toggleToTop = function () {
    toTop.classList.toggle('is-visible', window.scrollY > 100);
  };

  toggleToTop();
  window.addEventListener('scroll', toggleToTop, { passive: true });

  toTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});
